<template>
<v-container class="pa-5">
      <v-row no-gutters justify="center">
     <v-col
      sm="4"
     >
       <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
            <v-card style="margin-top: 12%; background: none;" class="pa-2 elevation-0">
              <p class="text-center pt-5">
              <img :src="$store.state.systemlogo" width="240px"/>
              </p>
              <v-card-text>
                    
                      <v-text-field
                        v-model="username"
                        :rules="nameRules"
                        label="Username"
                        required
                        outlined
                      ></v-text-field>
                   
                      <v-text-field
                        v-model="password"
                        :rules="nameRules"
                        label="Password"
                        type="password"
                        v-on:keyup.enter="validate()"
                        required
                        outlined
                      ></v-text-field>
                    
              </v-card-text>
              <v-card-actions class="pt-4 pb-5">
                  <v-btn
                        color="primary"
                        block
                        rounded
                        large
                        :loading="loading"
                        @click="loading=true,validate()"
                      >
                        LOGIN
                      </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
     </v-col>
   </v-row>
</v-container>
</template>
<script>
import md5 from 'md5'
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      valid: true,
      username: '',
      nameRules: [
        v => !!v || 'Field is required'
      ],
      password: '',
      loading: false,
      snackbar: false,
    }),
    created() {
      if (this.$session.exists()) {
          this.setLoggedIn(false)
          this.$session.destroy()
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      
      validate () {
        if (this.$refs.form.validate()) {
          this.login()
        }
      },
      login(){
         var param = {
            Username: this.username,
            Password: md5(this.password),
            machine_id: "35333130083634373639175C"
          }
          this.$http.post("user/login",param).then(response => {
          console.log( response.data)
          if(response.data.status == true) {
            if(response.data.account.role != "Administrator") {
              this.VA_ALERT("error", "No permission!")
              this.loading=false
              return
            }
            this.$session.start()
            this.$session.set('jwt', response.data.account.token)
            this.$session.set('username', response.data.account.username)
            this.$session.set('role', response.data.account.role)
            this.$session.set('userID', response.data.account.id)
             this.$session.set('areaID', response.data.account.area)
             this.$session.set('fullname', response.data.account.fullname)
            
            this.setAlertColor('success')
           
            this.SET_PERMISSION('game_set_up')
            this.SET_PERMISSION('game_stat_box')
           // this.SET_PERMISSION('set_admin')
              setTimeout(()=>{
                this.loading=false
                 this.setLoggedIn(true)
                   if(response.data.account.role == 'Agent') {
                  this.$router.push('/runner')
                } else {
                  this.$router.push('/dashboard')
                }
              }, 700)
               
            
          } else {
            this.setAlertColor('error')
            this.setLoggedIn(false)
             this.loading=false
          }
            this.setAlertText(response.data.message)
            this.setAlert(true)
          }).catch(e => {
           console.log(e)
         })
        
          
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>